module.exports = __webpack_public_path__ + "img/HMDX.64e36456.webp";